<template>
  <v-dialog v-if="items" v-model="show" max-width="1000px">
    <v-card>
      <v-data-table
        :disable-pagination="true"
        :headers="headers"
        :hide-default-footer="true"
        :items="items"
        :no-data-text="noDataFoundText"
        mobile-breakpoint="650"
      >
        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= 481 ? '' : 'pr-0']"
            color="primary"
            text
            @click="executeAction(item)"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.date="{ item }">
          {{ new Date(item.date) | moment('DD/MM/YYYY HH:mm:ss') }}
        </template>
      </v-data-table>
      <v-card-actions class="pa-0 pt-4">
        <v-btn block class="w-45" color="secondary" tile @click="$emit('close')">{{ $t('triggersHistories.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <error-details-dialog v-model="errorDialog" :error="targetedError" @close="errorDialog = false"/>
  </v-dialog>
</template>


<script>
import errorDetailsDialog from './ErrorDetailsDialog.vue'

export default {
  name: 'ListDialog',
  components: {
    errorDetailsDialog: errorDetailsDialog
  },
  data() {
    return {
      targetedError: undefined,
      errorDialog: false
    }
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      },
    },
    headers: {
      type: Array,
      default: function () {
        return []
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    noDataFoundText: {
      type: String,
      default: 'no data available'
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    executeAction(item) {
      this.targetedError = item
      this.errorDialog = true
    },
  },
}
</script>
<style scoped>
.w-45 {
  width: 45%;
}
</style>